import { useNavigate } from "react-router-dom";
import CustomTabs from "@/components/CustomTabs/CustomTabs";
import type { CustomTab } from "@/components/CustomTabs/CustomTabs";
import Button from "@/components/Button/Button";
import PlusIcon from "@/components/SVGComponents/PlusIcon";
import routes from "@/routes/routes";
import styles from "./GatheringsToolbar.module.scss";

interface GatheringsToolbarProps {
  tabs: CustomTab[];
  activeTab: string;
  onTabChange: (value: string) => void;
}

// City/Status filters and the decorative month pill were pulled for now —
// the filter Selects weren't reading well visually. Only the status-pill
// tabs and the Create Gathering entry point remain; re-add filtering once
// there's a design for it.
const GatheringsToolbar = ({ tabs, activeTab, onTabChange }: GatheringsToolbarProps) => {
  const navigate = useNavigate();

  return (
    <div className={styles.toolbar}>
      <CustomTabs tabs={tabs} activeTab={activeTab} onChange={onTabChange} />

      <div className={styles.rightControls}>
        <Button
          startIcon={<PlusIcon width={14} height={14} />}
          className={styles.createButton}
          onClick={() => navigate(routes.privateRoutes.GATHERINGS_CREATE.path)}
        >
          CREATE GATHERING
        </Button>
      </div>
    </div>
  );
};

export default GatheringsToolbar;
